module.exports = __webpack_public_path__ + "ec.ca34fc75.svg";